import axios from "axios";
import topbar from "topbar";
import $ from 'jquery';

let inflight = 0;

const overlayEl = () => document.getElementById('loadingOverlay');

const showOverlay = () => {
  inflight += 1;
  if (inflight === 1) {
    topbar.show();
    const el = overlayEl();
    if (el) el.style.display = 'flex';
  }
};

const hideOverlay = () => {
  inflight = Math.max(0, inflight - 1);
  if (inflight === 0) {
    topbar.hide();
    const el = overlayEl();
    if (el) el.style.display = 'none';
  }
};

const makeRequest = async (method, apiEndpoint, config = {}, data = {}) => {
  showOverlay();

  const headersConfig = {
    headers: {
      'x-api-key': '8c655bfc-a035-4b4c-af1a-39cf1a10bcdb',
      ...config.headers,
    },
  };

  const requestConfig = {
    ...config,
    ...headersConfig,
    method: method,
  };
  if (['post', 'put', 'patch', 'delete'].includes(method) && Object.keys(data).length) {
    requestConfig.data = data;
  }

  try {
    const response = await axios(apiEndpoint, requestConfig);
    hideOverlay();
    return response.data;
  } catch (error) {
    hideOverlay();

    if (error.response && error.response.status === 401) {
      console.log(error.response.status);
    } else if (error.response && error.response.data && error.response.data.message) {
      $.alert({
        title: 'Warning!',
        content: error.response.data.message,
        buttons: {
          ok: {
            text: 'OK',
            btnClass: 'btn-green'
          }
        }
      });
    } else {
      $.alert({
        title: 'Error!',
        content: 'An unexpected error occurred.',
        buttons: {
          ok: {
            btnClass: 'btn-red'
          }
        }
      });
    }

    throw error;
  }
};

const makeRequestForSearch = async (method, apiEndpoint, config = {}, data = {}) => {
  const headersConfig = {
    headers: {
      'x-api-key': '8c655bfc-a035-4b4c-af1a-39cf1a10bcdb',
      ...config.headers,
    },
  };

  const requestConfig = {
    ...config,
    ...headersConfig,
    method: method,
  };
  if (['post', 'put', 'patch', 'delete'].includes(method) && Object.keys(data).length) {
    requestConfig.data = data;
  }

  try {
    const response = await axios(apiEndpoint, requestConfig);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log(error.response.status);
    } else if (error.response && error.response.data && error.response.data.message) {
      $.alert({
        title: 'Warning!',
        content: error.response.data.message,
        buttons: {
          ok: {
            text: 'OK',
            btnClass: 'btn-green'
          }
        }
      });
    } else {
      $.alert({
        title: 'Error!',
        content: 'An unexpected error occurred.',
        buttons: {
          ok: {
            btnClass: 'btn-red'
          }
        }
      });
    }

    throw error;
  }
};

const fetchData = {
  get: (apiEndpoint, config = {}) => makeRequest('get', apiEndpoint, config),
  post: (apiEndpoint, config = {}, data = {}) => makeRequest('post', apiEndpoint, config, data),
  delete: (apiEndpoint, config = {}, data = {}) => makeRequest('delete', apiEndpoint, config, data),
  fetch: (apiEndpoint, config = {}, data = {}) => makeRequestForSearch('post', apiEndpoint, config, data),
};

export default fetchData;
